<template>
  <div class="bg-white" v-loading="loading">
    <div class="row">
      <div :class="modifiable ? 'col-12' : 'col-8 offset-2'">
        <div class="d-flex justify-content-between">
          <p class="fs-20 fw-500" v-if="!modifiable">{{ displayName }}</p>
        </div>
      </div>
      <div class="col-6" v-show="modifiable">
        <div class="box-shadow p-2">
          <div class="fs-18 fw-500 txt-grey-900 mb-3 max-line-1">{{ $t("schedule_page.lbl_add_indicator") }}</div>
          <div class="flex flex-col md:flex-row gap-3 items-center">
            <el-input :placeholder="$t('schedule_page.lbl_search_sh')" suffix-icon="el-icon-search" v-model="search"
                      :clearable="true" @keyup.enter.native="onSearch(search)"></el-input>
          </div>
          <div v-if="!type" class="flex space-x-3 my-3 select-class pb-1">
            <div class="cursor-pointer px-3 py-2 hover:bg-indigo-300 text-black rounded-lg class-item"
                 :class="!indicationClassParentId ? 'bg-indigo-200' : ''" :key="0 + 'level1'"
                 @click="selectIndicationClasses(0)">{{ $t("schedule_page.lbl_all") }}
            </div>
            <div class="cursor-pointer px-3 py-2 hover:bg-indigo-300 text-black rounded-lg class-item"
                 :class="indicationClassParentId === item.id ? 'bg-indigo-200' : 'bg-light'"
                 v-for="item in indicationClasses" :key="item.id + 'indicationClasses'"
                 @click="selectIndicationClasses(item.id)">{{ item.name }}
            </div>
          </div>
          <div class="h-tree select-items pt-2">
            <div v-infinite-scroll="handleNexPageCategories" :infinite-scroll-disabled="disabledScroll">
              <el-tree v-loading="indication_class_loading" class="filter-tree" :data="handledIndicationCategories"
                       check-on-click-node @check-change="handleCheckChange" show-checkbox ref="tree" node-key="id">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span class="fs-16 txt-grey-900 mb-0">{{ getIndicationName(data) || node.disabled }}</span>
                </span>
              </el-tree>
              <p class="text-center" v-if="indication_categories_loading">{{ $t("schedule_page.lbl_loading") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div :class="modifiable ? 'col-6 relative' : 'col-8 offset-2 relative'">
        <div class="mb-2">
          <div class="mb-1"><strong>Mẫu phiếu chỉ định</strong></div>
          <el-select class="w-full" v-model="selectedIndTemp" filterable remote reserve-keyword clearable
                     :remote-method="getIndTemps" placeholder="Chọn mẫu chỉ định hoặc tạo mới"
                     @change="handleSelectIndTemp" value-key="id">
            <el-option v-for="item in indTemps" :key="item.id" :label="item.name" :value="item">
              <div class="flex justify-between">
                <div>{{ item.name }}</div>
                <el-button @click.prevent.stop="deleteTemplate(item)" type="info" size="small" icon="el-icon-delete" class="m-1"></el-button>
              </div>
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="mb-1"><strong>Tên phiếu chỉ định</strong></div>
          <el-input placeholder="Tên phiếu chỉ định" v-model="localForm.name" :clearable="true" v-if="modifiable"
                    @input="onNameInput"></el-input>
        </div>
        <div class="selected-indication mt-2">
          <div class="selected-indication-item" :class="modifiable ? 'indication-item-hover' : ''"
               v-for="(indication, index) in (selectedIndications ? selectedIndications.filter(i => i && (i.local_name || i.name || (i.service_catalog && i.service_catalog.name))) : [])"
               :key="'idct' + index">
            <div class="flex align-items-center justify-content-between">
              <div class="w-100 p-1 flex justify-between items-center gap-1">
                <p class="fs-16 fw-500 txt-grey-900 mb-0 flex-1">{{ getIndicationName(indication) }}</p>
                <el-input-number class="cs-input" v-model="indication.indicationAmount" :min="1"></el-input-number>
              </div>
              <div class="delete-indication-wraper text-right">
                <span role="button" @click="handleDeleteIndication(indication)" class="delete-indication">
                  <i class="el-icon-close fs-22"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end mt-2" v-if="modifiable">
          <button class="btn btn-light mr-2" @click="handlerCancel">{{ $t("schedule_page.btn_cancel") }}</button>
          <button class="btn btn-light mr-2" @click="handleShowDialogSaveIndTemp">{{ $t("Lưu mẫu chỉ định") }}</button>
          <button :disabled="isDisabledCreate" class="btn bg-pri text-white" @click="onSubmit()">
            {{ $t(editing ? "Cập nhật" : "Tạo phiếu") }}
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('Tên mẫu phiếu chỉ định')"
      :visible.sync="showDialogSaveIndTemp"
      width="30%"
      append-to-body
      center
      :before-close="handleCancelSaveIndTemp"
    >
      <div>
        <el-input v-model="indTempName" :placeholder="$t('Nhập tên mẫu phiếu chỉ định')"></el-input>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-light mr-2" @click="handleCancelSaveIndTemp">{{ $t("schedule_page.btn_cancel") }}</button>
          <button :disabled="!indTempName" class="btn bg-pri text-white" @click="handleSaveIndTemp()">
            {{ $t("Lưu mẫu") }}
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  name: 'CUInficationOrder',
  mixins: [mixinHasFeatures],
  props: {
    type: { type: Number },
    order: { type: Object, required: false, default: () => ({}) },
    mr_id: { type: [String, Number], required: false },
    hr_id: { type: [String, Number], required: false }
  },
  data () {
    return {
      localForm: {
        id: 0,
        name: '',
        indications: [],
        updated_at: null,
        cate: null
      },
      search: '',
      indicationClasses: [],
      indicationClassParentId: null,
      indication_class_loading: false,
      indication_categories_loading: false,
      moment,
      editing: false,
      loading: false,
      indicationCategoriesPaging: {},
      count: 0,
      indicationServices: [],
      isDisabledCreate: false,
      stepConfirm: 0,
      selectedEcomService: [],
      selectedIndications: [],
      nameLocked: false,
      selectedIndTemp: null,
      indTemps: [],
      indTempName: '',
      showDialogSaveIndTemp: false
    }
  },
  async created () {
    const init = cloneDeep(this.order) || {}
    Object.assign(this.localForm, init)
    if (init && init.name) {
      this.nameLocked = true
    } else {
      if (!this.localForm.name) this.setDefaultName()
      this.nameLocked = false
    }
    if (Array.isArray(init.indications) && init.indications.length) {
      this.selectedIndications = cloneDeep(init.indications)
    }
    try {
      if (this.order && Object.keys(this.order).length > 0) this.editing = true
    } catch (e) {
    }
    await this.getIndicationClasses()
    await this.prepare()
  },
  watch: {
    'localForm.indications.length' (length) {
      if (length) {
        this.$nextTick(() => {
          if (this.indicationServices && this.indicationServices.length) this.handleSetCheckedKeys()
        })
      }
    },
    order (data) {
      const d = cloneDeep(data) || {}
      const { name, indications, ...rest } = d
      Object.assign(this.localForm, rest)
      if (name) {
        if (!this.localForm.name) this.localForm.name = name
        this.nameLocked = true
      }
      if (Array.isArray(indications) && indications.length) {
        this.selectedIndications = cloneDeep(indications)
      } else {
        this.selectedIndications = []
      }
    },
    indicationServices (val) {
      if (val && val.length && this.localForm.indications && this.localForm.indications.length) {
        this.$nextTick(() => this.handleSetCheckedKeys())
      }
    },
    selectedIndications: {
      handler (val) {
        if (val && Array.isArray(val) && val.length) {
          this.localForm.indications = cloneDeep(val)
        } else {
          this.localForm.indications = []
          this.selectedIndTemp = null
        }
      },
      deep: true
    },
    selectedIndTemp: {
      handler (val) {
        if (!val || !val.id) {
          this.selectedIndications = []
          this.handleSetCheckedKeys()
          return
        }
        this.handleSelectIndTemp(val)
      },
      deep: true
    }
  },
  computed: {
    handledIndicationCategories () {
      if (!this.indicationServices) return []
      let result = this.indicationServices.map(ig => ig)
      return result
    },
    modifiable () {
      try {
        const hasOrderObject = this.order && typeof this.order === 'object' && Object.keys(this.order).length > 0
        return !hasOrderObject || !!this.editing
      } catch (e) {
        return !!this.editing
      }
    },
    displayName () {
      try {
        return this.order && this.order.name ? this.order.name : this.localForm.name
      } catch (e) {
        return this.localForm.name
      }
    },
    noMore () {
      return (
        !this.indicationCategoriesPaging?.total_page ||
        this.indicationCategoriesPaging.current_page >=
        this.indicationCategoriesPaging.total_page
      )
    },
    disabledScroll () {
      return (
        this.indication_class_loading ||
        this.indication_categories_loading ||
        this.noMore
      )
    }
  },
  methods: {
    onNameInput () {
      this.nameLocked = true
    },
    async prepare () {
      await Promise.all([
        this.getIndicationsCategories(),
        this.handlerIndicationsOrder(),
        this.getIndTemps()
      ])
      // this.getIndicationsCategories()
      // this.handlerIndicationsOrder()
    },
    onSearch (search) {
      this.search = search
      this.getIndicationsCategories()
    },
    async getIndicationClasses () {
      const params = { level: 1, all: true }
      this.indication_class_loading = true
      const res = await this.$rf.getRequest('DoctorRequest').getIndicationClasses(params)
      this.indicationClasses = res?.data
      this.indication_class_loading = false
    },
    handleNexPageCategories () {
      if (this.noMore) return
      this.getIndicationsCategories(true)
    },
    async getIndicationsCategories (isNext = false) {
      if (!this.$globalClinic?.id) return
      if (!isNext) this.indicationServices = []
      const params = {
        keyword: this.search,
        page_num:
          isNext && this.indicationCategoriesPaging.current_page < this.indicationCategoriesPaging.total_page
            ? this.indicationCategoriesPaging.current_page + 1
            : 1,
        group_id: this.type,
        page_size: 1000,
        ws_id: this.$globalClinic?.id
      }
      if (!params.level1) delete params.level1
      if (!params.search) delete params.search
      this.indication_categories_loading = true
      try {
        const res = await this.$rf.getRequest('DoctorRequest').getLocalService(params)
        const { data: results, page } = res.data
        const newData = results?.map(item => ({ ...item, local_service_id: item?.service_locals?.id }))
        this.indicationServices = isNext ? [...this.indicationServices, ...newData] : newData
        this.indicationCategoriesPaging = { ...page, current_page: page?.page_num || 1 }
        this.indication_categories_loading = false
        return true
      } catch (error) {
        console.error(error)
        this.indication_categories_loading = false
        return false
      }
    },
    selectIndicationClasses (classId) {
      this.indicationClassParentId = classId || null
      this.getIndicationsCategories()
    },

    async onSubmit () {
      if (!this.localForm.name) {
        this.$message({ type: 'error', message: this.$t(`Vui lòng nhập tên phiếu chỉ định.`) })
        return
      }
      const checkedList = this.selectedIndications
      const newOrder = {
        id: this.order && this.order.id ? this.order.id : 0,
        name: this.localForm.name,
        indications: [...checkedList],
        updated_at: new Date().toISOString(),
        cate: this.type
      }
      this.$emit('update', newOrder)
      this.isDisabledCreate = true
      this.loading = false
    },
    handlerCancel () {
      this.prepare()
      if (this.order && Object.keys(this.order).length > 0) {
        this.$emit('refresh', { reCall: true })
      } else {
        this.$emit('refresh')
      }
    },
    setDefaultName () {
      if (!this.localForm) this.localForm = {}
      this.localForm.name = this.$t('schedule_page.lbl_indication_sheet') + moment().format('HH:mm:ss DD-MM-YYYY')
    },
    handlerIndicationsOrder () {
      if (this.order) {
        this.localForm.id = 0
        this.localForm.updated_at = this.order.updated_at || this.localForm.updated_at || new Date().toISOString()
        this.localForm.cate = this.order.cate || this.type

        if (Array.isArray(this.order.indications) && this.order.indications.length) {
          const items = this.order.indications.map(item => ({
            ...item,
            id: item.id || item.type_service_id,
            indicationAmount: item?.indicationAmount || 1,
            local_name: item.local_name || item.name
          }))
          this.localForm.indications = items
          this.selectedIndications = cloneDeep(items)
          items.forEach(it => {
            const exists = this.indicationServices?.find(s => String(s.id) === String(it.id))
            if (!exists) {
              this.indicationServices = [{
                id: it.id,
                local_name: it.local_name || it.name,
                service_catalog: it.service_catalog || {}
              }, ...(this.indicationServices || [])]
            }
          })
          this.handleSetCheckedKeys()
          return
        }

        if (this.indicationServices?.length) {
          const arr = this.indicationServices.map(item => ({
            ...item,
            indication_category_id: item.service_catalog?.services_category_id,
            name: item.local_name,
            services_code: item.service_catalog?.services_code,
            status: item.status,
            type_service: 2,
            type_service_id: item.id,
            indicationAmount: item?.indicationAmount || 1
          }))
          this.localForm.indications = arr
          this.handleSetCheckedKeys()
        }
      }
    },
    handleCheckChange (data, checked, handle) {
      const _tempSelected = this.selectedIndications || []
      if (!checked) {
        const arr = _tempSelected?.filter(item => item.id !== data.id)
        this.selectedIndications = arr.map(item => ({ ...item, indicationAmount: item?.indicationAmount || 1 }))
        if (handle) {
          this.handleSetCheckedKeys()
        }
        return
      }
      const foundData = _tempSelected?.find(item => item.id === data.id)
      if (foundData || typeof foundData !== 'undefined') return
      this.selectedIndications = [
        ..._tempSelected,
        {
          ...data,
          id: data.id,
          indication_category_id: data.service_catalog?.services_category_id,
          name: data.name,
          services_code: data.service_catalog?.services_code,
          status: data.status,
          type_service: 2,
          type_service_id: data.id,
          indicationAmount: 1
        }
      ]
    },
    handleSetCheckedKeys () {
      const attemptSet = async (triesLeft = 5) => {
        try {
          if (!this.$refs || !this.$refs.tree) {
            if (triesLeft > 0) return setTimeout(() => attemptSet(triesLeft - 1), 100)
            return
          }
          const tree = this.$refs.tree
          const indications = this.localForm.indications || []
          if (!indications.length) {
            tree.setCheckedKeys([])
            return
          }
          const codes = indications.map(item => item?.id).filter(Boolean)

          try {
            tree.setCheckedKeys(codes)
          } catch (e) {
          }

          try {
            codes.forEach(key => {
              const node = tree.getNode(key)
              if (node && !node.checked) {
                tree.setChecked(node.data, true, false)
              }
            })
          } catch (e) {
          }
        } catch (error) {
          if (triesLeft > 0) return setTimeout(() => attemptSet(triesLeft - 1), 100)
        }
      }

      this.$nextTick(() => attemptSet())
    },
    handleDeleteIndication (data) {
      if (!data) return
      this.selectedEcomService = this.selectedEcomService?.filter(item => item?.id != data?.id)
      this.handleCheckChange(data, false, true)
    },
    getIndicationName (data) {
      return data?.local_name
    },
    async getIndTemps (searchValue) {
      if (!this.$globalClinic?.id) return
      const params = {
        clinic_id: this.$globalClinic?.id,
        type: this.type || null,
        keyword: searchValue || '',
        page_size: 1000,
        page_num: 1
      }
      try {
        const res = await this.$rf.getRequest('DoctorRequest').getIndTemps(params)
        this.indTemps = res?.data?.data || []
      } catch (error) {
        console.error(error)
      }
    },
    handleSelectIndTemp (selected) {
      if (!selected || !selected.id) return
      if (Array.isArray(selected.indication_forms) && selected.indication_forms.length) {
        const items = selected.indication_forms.map(item => ({
          ...item.service_catalog,
          id: item.service_catalog?.id,
          indicationAmount: item?.indicationAmount || 1,
          local_name: item?.local_name || item?.service_catalog?.name,
          type_service: 2,
          type_service_id: item.service_catalog?.id,
          service_catalog: item.service_catalog || {}
        }))
        this.selectedIndications = cloneDeep(items)
      }
    },
    async deleteTemplate (item) {
      this.$confirm(`Bạn chắc chắn muốn xoá mẫu phiếu <strong>${item.name}</strong> không?`, 'Xác nhận xoá mẫu phiếu', {
        confirmButtonText: 'Xác nhận',
        dangerouslyUseHTMLString: true
      }).then(async _ => {
        this.loading = true
        await this.$rf
          .getRequest('DoctorRequest')
          .deleteIndTemp(item.id)
          .then(async r => {
            if (r?.code === 200) {
              await this.getIndTemps()
              this.selectedIndications = []
              this.selectedIndTemp = null
              this.$message({
                message: 'Xoá template thành công',
                type: 'success'
              })
            } else {
            }
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    handleShowDialogSaveIndTemp () {
      if (!this.selectedIndications || !this.selectedIndications.length) {
        this.$message({ type: 'error', message: this.$t(`Vui lòng chọn chỉ định để lưu mẫu.`) })
        return
      }
      this.showDialogSaveIndTemp = true
    },
    handleCancelSaveIndTemp () {
      this.showDialogSaveIndTemp = false
      this.indTempName = ''
    },
    handleSaveIndTemp () {
      if (!this.indTempName) {
        this.$message({ type: 'error', message: this.$t(`Vui lòng nhập tên mẫu phiếu chỉ định.`) })
        return
      }
      const payload = {
        name: this.indTempName,
        clinic_id: this.$globalClinic?.id,
        type: this.type || null,
        indication_forms: this.selectedIndications.map(item => ({
          services_code: item.services_code
        }))
      }
      this.loading = true
      this.$rf
        .getRequest('DoctorRequest')
        .createIndTemp(payload)
        .then(async r => {
          if (r?.status === 200) {
            await this.getIndTemps()
            this.$message({
              message: 'Lưu mẫu phiếu chỉ định thành công',
              type: 'success'
            })
            this.handleCancelSaveIndTemp()
            this.selectedIndTemp = r?.data || null
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__body {
    padding: 16px 10px;
  }

  .el-tree-node__content {
    height: 48px;
  }

  .input-deal-date .el-input__inner {
    border: 0;
    background-color: white !important;
    font-size: 14px;
    font-weight: normal !important;
    color: #667085 !important;
  }

  .input-deal-date .el-input__inner::-webkit-input-placeholder {
    color: #667085;
    opacity: 1;
  }
}

.h-40px {
  height: 40px;
}

.disable-click {
  pointer-events: none;
  opacity: 0.7;
}

.select-items {
  height: calc(100vh - 300px);
  overflow-x: hidden;
  overflow-y: auto;
}

.select-class {
  overflow-x: auto;
  width: 100%;
}

.class-item {
  white-space: nowrap;
  flex-grow: 1;
}

.delete-indication-wraper {
  width: 40px;
}

.delete-indication {
  display: none;
  cursor: pointer;
}

.btn-add {
  &:hover {
    background: #ecf5ff;
  }
}

.indication-item-hover:hover .delete-indication {
  display: block;
}

.selected-indication {
  padding-right: 8px;
  height: calc(100vh - 300px);
  overflow-y: auto;
}

.selected-indication-item {
  margin-bottom: 16px;
  border-radius: 10px;
  border: 0.5px solid #e6e6e6;
  padding: 8px;
}

.selected-indication-item:hover {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

.box-shadow {
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
}

.custom-tree-node {
  white-space: pre-wrap;
}

.cs-input {
  max-width: 150px;
  text-align: center;
}
</style>
